import {
    GET_CMS_BANNER
} from "../actions/types";

const initialState = [];
const cmsReducer = function (state=initialState, action) {
    const {type, payload } = action;    
    switch (type) {        
        case GET_CMS_BANNER:
            return {
                ...state,
                contentBanner: payload.data
            }
        default:
            return state;
    }
};

export default cmsReducer;